var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fb-customerchat",attrs:{"id":"fb-customer-chat"}})
}
var staticRenderFns = []

export { render, staticRenderFns }